import { cancelPersistQuestionnaireEditor } from "@/store/studea_manager/questionnaire-editor-persistence";

class StorageManager {
  url = null;

  initListener() {
    const app = document.getElementById("app");
    app.addEventListener("contextmenu", (event) => {
      const closestLink = event.target.closest("a");
      if (closestLink && closestLink.href) {
        this.prepareNewTab(closestLink.href);
      }
      window.removeEventListener("click", this.newClick);
      window.addEventListener("click", this.newClick);
    });

    app.addEventListener("click", (event) => {
      const closestLink = event.target.closest("a");
      if (closestLink && closestLink.target === "_blank" && closestLink.href) {
        this.prepareNewTab(closestLink.href);
      }
    });

    this.setFromLocalStorage();
  }

  prepareNewTab(href) {
    localStorage.setItem("studea-currentRoute", href);
    localStorage.setItem("studea-newTab", "1");
    localStorage.setItem("studea-sessionStorage", JSON.stringify(sessionStorage));
  }

  setFromLocalStorage() {
    let sStorage = null;
    let newTab = null;
    if (localStorage.getItem("studea-sessionStorage")) {
      sStorage = JSON.parse(localStorage.getItem("studea-sessionStorage"));
      newTab = localStorage.getItem("studea-newTab") && localStorage.getItem("studea-newTab") === "1";
    }

    if ((!sessionStorage.length || newTab) && sStorage) {
      if (localStorage.getItem("studea-sessionStorage")) {
        for (var key in sStorage) {
          if (key !== "studea-sessionTS") {
            sessionStorage.setItem(key, sStorage[key]);
          }
        }
        localStorage.removeItem("studea-sessionStorage");
        localStorage.removeItem("studea-newTab");

        if (!window.sessionStorage.getItem("studea-sessionTS")) {
          window.location.href = window.localStorage.getItem("studea-currentRoute");
        }
      }
    }
  }

  // Ce click "d'annulation" (clic ailleurs après un clic droit qui n'a pas ouvert de nouvel
  // onglet) doit purger le relais entier, pas seulement studea-newTab : sinon
  // studea-sessionStorage/studea-currentRoute restent sur disque jusqu'au prochain rechargement
  // consommateur ou au logout, alors qu'aucun nouvel onglet ne viendra jamais les lire.
  newClick() {
    localStorage.removeItem("studea-newTab");
    localStorage.removeItem("studea-sessionStorage");
    localStorage.removeItem("studea-currentRoute");
  }

  // Les clés `studea-refreshToken` / `studea-initial-refreshToken` ne sont plus écrites depuis
  // ST143-TI-18073 (le refresh token vit uniquement dans un cookie HttpOnly), mais leur purge est
  // conservée : les utilisateurs déjà connectés au moment du déploiement en ont encore une copie
  // sur disque, et elle doit disparaître à la première déconnexion.
  clear() {
    //Session
    window.sessionStorage.removeItem("studea-token");
    window.sessionStorage.removeItem("studea-refreshToken");
    window.sessionStorage.removeItem("studea-tokenExpirationDate");
    window.sessionStorage.removeItem("studea-sessionTS");
    window.sessionStorage.removeItem("studea-initial-refreshToken");
    window.sessionStorage.removeItem("studea-initial-token");
    window.sessionStorage.removeItem("studea-initial-oldTriad");
    window.sessionStorage.removeItem("studea-initial-oldTrainingCourse");
    window.sessionStorage.removeItem("studea-initial-tokenExpirationDate");
    window.sessionStorage.removeItem("studea-switched");
    window.sessionStorage.removeItem("studea-schedule-invoice-queue");

    //Local
    window.localStorage.removeItem("studea-token");
    window.localStorage.removeItem("studea-username");
    window.localStorage.removeItem("studea-refreshToken");
    window.localStorage.removeItem("studea-tokenExpirationDate");
    cancelPersistQuestionnaireEditor();
    window.localStorage.removeItem("studea-questionnaireEditor");
    window.localStorage.removeItem("studea-oldTriad");
    window.localStorage.removeItem("studea-oldTrainingCourse");
    window.localStorage.removeItem("studea-initial-refreshToken");
    window.localStorage.removeItem("studea-initial-tokenExpirationDate");
    window.localStorage.removeItem("studea-initial-token");
    window.localStorage.removeItem("studea-stayConnected");
    window.localStorage.removeItem("studea-switched");
    window.localStorage.removeItem("studea-returnPathName");
  }
}

export const storageManager = new StorageManager();
